/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Polyfill for `DOMTokenList.prototype.toggle(token, opt_force)` method. This
 * is specially important because IE does not support `opt_force` attribute. See
 * https://goo.gl/hgKNYY for details.
 * @param {string} token
 * @param {boolean=} opt_force
 * @this {DOMTokenList}
 * @return {boolean}
 */
function domTokenListTogglePolyfill(token, opt_force) {
  // eslint-disable-next-line local/no-invalid-this
  const remove = opt_force === undefined ? this.contains(token) : !opt_force;
  if (remove) {
    // eslint-disable-next-line local/no-invalid-this
    this.remove(token);
    return false;
  } else {
    // eslint-disable-next-line local/no-invalid-this
    this.add(token);
    return true;
  }
}

/**
 * Polyfills `DOMTokenList.prototype.toggle` API and makes `.add` accepts N
 * classes in IE.
 * @param {!Window} win
 */
export function install(win) {
  if (isIe(win) && win.DOMTokenList) {
    win.Object.defineProperty(win.DOMTokenList.prototype, 'toggle', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: domTokenListTogglePolyfill,
    });

    const {add} = win.DOMTokenList.prototype;
    win.DOMTokenList.prototype.add = function () {
      for (let i = 0; i < arguments.length; i++) {
        add.call(this, arguments[i]);
      }
    };
  }
}

/**
 * Whether the current browser is a IE browser.
 * @param {!Window} win
 * @return {boolean}
 */
function isIe(win) {
  return /Trident|MSIE|IEMobile/i.test(win.navigator.userAgent);
}
